import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { toast } from "sonner";
import { Lock, User } from "lucide-react";

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [sifre, setSifre] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!sifre) {
      toast.error("Lütfen şifrenizi girin");
      return;
    }

    setLoading(true);

    // Şifre kontrolü
    if (sifre === "miba2024" || sifre === "finans123" || sifre === "patron2024") {
      // Create a simple user session
      const user = {
        user_id: "patron_user",
        name: "Patron",
        email: "patron@otoyedekparca.com",
        company_name: "OTO YEDEK PARÇA"
      };
      
      login(user);
      toast.success("Hoş geldiniz!");
      navigate("/dashboard", { replace: true });
    } else {
      toast.error("Şifre hatalı!");
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin(e);
    }
  };

  return (
    <div className="login-container" data-testid="login-page">
      {/* Left Side - Image */}
      <div className="login-left">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A0A0B] to-[#1a1a1b]">
          <img
            src="https://images.unsplash.com/photo-1763836393379-68f9721966ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxhdXRvJTIwc3BhcmUlMjBwYXJ0cyUyMGVuZ2luZXxlbnwwfHx8fDE3NzQ1MTk1MzN8MA&ixlib=rb-4.1.0&q=85"
            alt="Auto Parts"
            className="w-full h-full object-cover opacity-40 mix-blend-luminosity"
          />
        </div>
        <div className="absolute inset-0 flex flex-col justify-end p-12">
          <h1 className="font-heading text-5xl font-black text-white tracking-tighter mb-4">
            OTO YEDEK PARÇA
          </h1>
          <p className="text-white/70 text-lg max-w-md">
            Şirketinizi tek bir merkezden yönetin. Gelir, gider, satış ve tahsilat takibi artık çok kolay.
          </p>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="login-right bg-white">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-[#002FA7] rounded-sm flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <span className="font-heading font-bold text-xl text-[#0A0A0B]">FinansKontrol</span>
            </div>
            <p className="text-[#5E5E62] text-sm">Şirket Yönetim Paneli</p>
          </div>

          {/* Welcome Text */}
          <div className="mb-8">
            <h2 className="font-heading text-2xl font-bold text-[#0A0A0B] tracking-tight mb-2">
              Hoş Geldiniz
            </h2>
            <p className="text-[#5E5E62]">
              Devam etmek için şifrenizi girin.
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#0A0A0B] mb-2">
                <Lock className="inline h-4 w-4 mr-1" />
                Şifre
              </label>
              <input
                type="password"
                value={sifre}
                onChange={(e) => setSifre(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Şifrenizi girin"
                className="input-default h-12"
                autoFocus
                data-testid="password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="login-btn"
              className="w-full btn-primary h-12 flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Giriş Yapılıyor...
                </>
              ) : (
                "Giriş Yap"
              )}
            </button>
          </form>

          {/* Footer */}
          <p className="mt-8 text-center text-xs text-[#A1A1AA]">
            Giriş yaparak kullanım koşullarını kabul etmiş olursunuz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
